import { create } from "zustand";
import * as THREE from "three";
import { RefObject } from "react";

interface Experience {
  status: "idle" | "playing";
  wantsPlay: boolean;
  sceneReady: boolean;
  speed: number; // km/h
  vehicleRef: RefObject<THREE.Object3D | null>;
  pause: () => void;
  play: () => void;
  requestPlay: () => void;
  setSceneReady: () => void;
  resetScene: () => void;
  setSpeed: (speed: number) => void;
  setVehicleRef: (ref: RefObject<THREE.Object3D | null>) => void;
}

export const useExperience = create<Experience>()((set, get) => ({
  status: "idle",
  wantsPlay: false,
  sceneReady: false,
  speed: 0,
  vehicleRef: { current: null },
  pause: () => set(() => ({ status: "idle", wantsPlay: false })),
  play: () => set(() => ({ status: "playing", speed: 0 })),
  requestPlay: () =>
    get().sceneReady
      ? set(() => ({ status: "playing", speed: 0, wantsPlay: true }))
      : set(() => ({ wantsPlay: true })),
  setSceneReady: () => set(() => ({ sceneReady: true })),
  resetScene: () => set(() => ({ sceneReady: false, wantsPlay: false })),
  setSpeed: (speed) => set(() => ({ speed })),
  setVehicleRef: (ref) => set(() => ({ vehicleRef: ref })),
}));
